import React, { FC } from 'react';

import { AppLayoutBreakpoint, useContainerWidth } from '../../../../util/responsiveness';
import { useContentContainerContext } from '../../hooks';

import SubHeader from './SubHeader';
import { SubHeaderRowProps } from './SubHeaderRow.types';

const SubHeaderRow: FC<SubHeaderRowProps> = ({ children, forceVisibleAtAllBreakpoints }) => {
  const { shouldShowSubHeaderAtAllBreakpoints } = useContentContainerContext();

  const width = useContainerWidth();
  const shouldShowInCurrentWidth = shouldShowSubheaderAtWidth(width);
  const shouldRender =
    children && (shouldShowInCurrentWidth || forceVisibleAtAllBreakpoints || shouldShowSubHeaderAtAllBreakpoints);

  if (!shouldRender) {
    return null;
  }

  return <SubHeader>{children}</SubHeader>;
};

export default SubHeaderRow;

export const shouldShowSubheaderAtWidth = (breakpoint: number) => breakpoint < AppLayoutBreakpoint.Width812;
